/**
 * Design tokens for the RUNNUR Master Data Dashboard.
 * These are bound to AntD's ConfigProvider at the app root
 * (see src/theme/ThemeProvider.tsx).
 *
 * The semantic token system means all colors are names, not values;
 * dark mode and theme variants can swap underlying values without
 * changing component code.
 */
export const colorTokens = {
  // Brand
  brandPrimary: '#1f4e3d', // RUNNUR forest green
  brandPrimaryHover: '#2d6a52',
  brandPrimaryBg: '#e6f2ec',

  // Semantic
  success: '#52c41a',
  warning: '#faad14',
  error: '#ff4d4f',
  info: '#1677ff',
  scheduled: '#722ed1',
  published: '#13c2c2',
  suspended: '#fa541c',

  // Neutrals
  textHeading: '#0f172a',
  textBody: '#475569',
  textMuted: '#94a3b8',
  border: '#e5e7eb',
  bgLayout: '#f5f7fa',
  bgContainer: '#ffffff',
  bgElevated: '#ffffff',

  // States
  draft: '#94a3b8',
  draftBg: '#f1f5f9',
  submitted: '#1677ff',
  submittedBg: '#e6f4ff',
  underReview: '#faad14',
  underReviewBg: '#fff7e6',
  approved: '#52c41a',
  approvedBg: '#f6ffed',
  rejected: '#ff4d4f',
  rejectedBg: '#fff1f0',
  archived: '#595959',
  archivedBg: '#fafafa',
} as const;

export const spacingTokens = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  xxl: 32,
  xxxl: 48,
} as const;

export const radiusTokens = {
  sm: 4,
  md: 6,
  lg: 8,
  xl: 12,
} as const;

export const elevationTokens = {
  card: '0 1px 2px rgba(15, 23, 42, 0.06), 0 1px 6px rgba(15, 23, 42, 0.04)',
  modal: '0 6px 16px rgba(15, 23, 42, 0.12), 0 3px 6px rgba(15, 23, 42, 0.08)',
  popover: '0 4px 12px rgba(15, 23, 42, 0.1)',
} as const;

export const typographyTokens = {
  h1: { fontSize: 24, fontWeight: 600, lineHeight: 1.3 },
  h2: { fontSize: 20, fontWeight: 600, lineHeight: 1.3 },
  h3: { fontSize: 16, fontWeight: 600, lineHeight: 1.4 },
  body: { fontSize: 14, fontWeight: 400, lineHeight: 1.5 },
  bodyStrong: { fontSize: 14, fontWeight: 500, lineHeight: 1.5 },
  caption: { fontSize: 12, fontWeight: 400, lineHeight: 1.4 },
  code: { fontSize: 13, fontFamily: 'ui-monospace, SFMono-Regular, monospace' },
} as const;